"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarginOrderEstimates = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _APLabelWithText = _interopRequireDefault(require("../../common/APLabelWithText"));
var _useMaxAmount = require("./useMaxAmount");
var _useBorrowingAmount = require("./useBorrowingAmount");
var _useHourlyInterest = require("./useHourlyInterest");
var _reactRedux = require("react-redux");
var _orderEntrySelector = require("../../../redux/selectors/orderEntrySelector");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var MarginOrderEstimates = exports.MarginOrderEstimates = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var baseClass = _ref.baseClass,
    formName = _ref.formName;
  var _useTranslation = (0, _reactI18next.useTranslation)('margin'),
    t = _useTranslation.t;
  var maxAmount = (0, _useMaxAmount.useMaxAmount)();
  var borrowingAmount = (0, _useBorrowingAmount.useBorrowingAmount)(formName);
  var hourlyInterest = (0, _useHourlyInterest.useHourlyInterest)(formName);
  var isBuy = (0, _reactRedux.useSelector)(function (state) {
    return (0, _orderEntrySelector.selectIsBuyForm)(state, {
      formName: formName
    });
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: isBuy ? t('Max Buy Amount') : t('Max Sell Amount'),
    text: "".concat(maxAmount.symbol, " ").concat(maxAmount.formatted),
    customClass: baseClass
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    name: "borrowing",
    label: t('Borrowing'),
    text: "".concat(borrowingAmount.symbol, " ").concat(borrowingAmount.formatted),
    customClass: baseClass
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    name: "hourlyInterest",
    label: t('Hourly Interest'),
    text: "".concat(hourlyInterest.toLocaleString(undefined, {
      maximumFractionDigits: 8
    }), "%"),
    customClass: baseClass
  }));
});
MarginOrderEstimates.displayName = 'MarginOrderEstimates';